// ShamsiDatePicker.js
import React from "react";
import DatePicker from "react-multi-date-picker";
import { persian, customLocale } from "./customLocale";
import "./ShamsiDatePicker.css";
import { TextField } from "@mui/material";
const ShamsiDatePicker = ({ value, onChange, label, placeholder, onFocus, className, disabled, sx, min, max }) => {
  return (
    <div>
      {
        label && (
          <label>{label}</label>
        )
      }

      <DatePicker
        value={value}
        onChange={onChange}
        calendar={persian}
        locale={customLocale}
        format="YYYY/MM/DD"
        placeholder={placeholder}
        onOpenPickNewDate={false}
        minDate={min}
        maxDate={max}
        render={(_value, openCalender, _onChange) => {
          return <TextField
            onFocus={() => openCalender()}
            fullWidth
            label={placeholder || ""}
            placeholder={placeholder || ""}
            value={_value}
            onInput={_onChange}
            className={className ? className : ""}
            autoComplete="off"
            disabled={disabled}
            sx={{
              ".css-14kome0-MuiInputBase-root-MuiOutlinedInput-root": {
                padding: 0
              },
              "& input": {
                padding: "10.5px 8px  !important"
              },
              ...sx
            }}
          />
        }
        }
      />
    </div>
  );
};

export default ShamsiDatePicker;
